import { BaseApi } from "@/api/BaseApi";
import Config from "@/const/Config";
import { Koukyuu, KoukyuuDetail } from '@/types/Shinsei'
export class KoukyuuApi extends BaseApi {

  /**
   * 公休申請を登録します
   * @returns
   */
  public async createShinsei(req: Koukyuu) {
    try {
      return await this.post<Koukyuu>(Config.API_URL + "/shinsei/no_approval/koukyuu/", req);
    } catch (e: unknown) {
      throw e;
    }
  }

  /**
   * 公休申請を削除します
   * @returns
   */
  public async deleteShinsei(koukyuuId: number) {
    try {
      return await this.delete(Config.API_URL + "/shinsei/no_approval/koukyuu/", {koukyuuId: koukyuuId});
    } catch (e: unknown) {
      throw e;
    }
  }
  
  /**
   * 詳細を取得します
   * @returns
   */
  public async getDetail(id: number): Promise<KoukyuuDetail> {
    try {
      const req = {
        id
      }
      const res = await this.post<KoukyuuDetail>(Config.API_URL + "/shinsei/no_approval/koukyuu/detail/", req);
      return res.data
    } catch (e: unknown) {
      throw e;
    }
  }
}
